import React from 'react';
import PropTypes from 'prop-types';
import DisciplinaCard from './DisciplinaCard';
import { CardContext } from '../../hoc/withCards';
import ListFilter from '../common/list-filter/ListFilter';

const DisciplineList = ({ renderLoading, onChangeForm }) => {
  return (
    <CardContext.Consumer>
      {({ cards }) => (
        <>
          <ListFilter
            type="text"
            searchInputLabel="Nome da disciplina"
            onValueChange={onChangeForm}
          />
          <div className="card-deck">
            {renderLoading() ||
              cards.map((card) => (
                <DisciplinaCard key={card.id} id={card.id} nome={card.nome} />
              ))}
          </div>
        </>
      )}
    </CardContext.Consumer>
  );
};

DisciplineList.propTypes = {
  renderLoading: PropTypes.func.isRequired,
  onChangeForm: PropTypes.func.isRequired,
};

export default DisciplineList;
